import React from "react";

const Pricing = ({ children }) => <div className="row">{children}</div>;

export default Pricing;
